import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spin, Select } from 'antd';
import { type AppDispatch } from '../../../redux/store';
import { getUnpledgedSalesAction } from '../../Sales/store/salesActions';
import { resetUnpledgedSales } from '../../Sales/store/salesReducer';

export const UnpledgedSalesIndex = () => {
  const dispatch = useDispatch<AppDispatch>();

  const [branchOptions, setBranchOptions] = useState<
    Array<{
      label: string;
      value: string;
    }>
  >([]);

  useEffect(() => {
    const branches = localStorage.getItem('branches');
    if (branches != null) {
      const parsedBranches = JSON.parse(branches);
      const branchOptionTemp: Array<{ label: string; value: string }> =
        parsedBranches.map((branch: { code: string; id: string }) => ({
          label: branch.code,
          value: branch.id,
        }));
      setBranchOptions(branchOptionTemp);
    }
  }, []);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [value, setValue] = useState<string>('');

  const { unpledgedSales }: any = useSelector<any>((state) => state?.sales);

  const getUnpledgedSales = async (): Promise<void> => {
    setIsLoading(true);
    await getUnpledgedSalesAction(dispatch, { branch: value });
    setIsLoading(false);
  };

  useEffect(() => {
    if (value === '') {
      resetUnpledgedSales();
    } else {
      void getUnpledgedSales();
    }
  }, [value]);

  return (
    <div>
      <Spin spinning={isLoading} fullscreen />
      <h4>Branch</h4>
      <Select
        style={{ width: 311, height: 56 }}
        placeholder="Select branch"
        onChange={(selectedvalue: string): void => {
          setValue(selectedvalue);
        }}
        options={branchOptions}
        className="deposit__select"
      />
      {value !== '' && unpledgedSales.length === 0 && (
        <p>No unpledged sales found for this branch</p>
      )}
      {value.length > 0 && (
        <div
          style={{
            marginTop: 100,
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
          }}
        >
          {unpledgedSales.map((x: any) => (
            <div
              key={x}
              style={{
                display: 'flex',
                flexDirection: 'row',
                gap: 16,
                alignItems: 'center',
              }}
            >
              <a
                href={`/customer?saleNumber=${x.saleNumber}`}
                style={{
                  color: '#DD1E2D',
                  cursor: 'pointer',
                  textDecoration: 'none',
                }}
              >
                {x.saleNumber}
                {x.salesPledged === 'partial' ? '*' : ''}
              </a>
              <p>
                {x.customerDetails.customerId} ({x.customerDetails.name})
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
